'use strict';

export default {

    guest: true,

    login(email, password, csrf) {
        return new Promise((resolve, reject) => {

            let headers = {
                'Accept': 'application/json',
            };

            if (csrf) {
                headers['X-CSRF-TOKEN'] = csrf;
            }

            axios({
                method: 'post',
                url: '/login',
                headers: headers,
                data: {
                    email: email,
                    password: password,
                }
            })
            .then(response => {
                this.guest = false;
                resolve(response);
            }).catch(errors => {
                reject(errors);
            });
        });
    },

    register(payload) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/register',
                headers: {
                    'Accept': 'application/json'
                },
                data: payload
            })
            .then(response => {
                resolve(response.data);
            }).catch(errors => {
                reject(errors);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Auth.js